// Las dos figuras de la marca de MiPAE, en SVG en línea. Una sola fuente para
// el header (LockupHeader) y el pie del inicio (2026-10-17, "Con la marca").
// Mismas formas que public/logo-mark-header.svg; los colores son variables de
// identidad (--marca-principal / --marca-acompanante, en src/index.css) para
// que la marca se vea en modo oscuro sin la caja blanca y siga al tema.
export default function MarcaMiPAE({ className = "h-[22px] w-auto flex-shrink-0" }) {
  return (
    <svg viewBox="0 0 56 40" className={className} aria-hidden="true" focusable="false">
      <circle cx="20" cy="10.5" r="8.5" fill="var(--marca-principal)" />
      <circle cx="37.5" cy="14.5" r="6.5" fill="var(--marca-acompanante)" />
      <path
        d="M8 22.1C11.2 20.1 15.3 19 20 19C24.8 19 28.9 20.1 32 22.1V31.8C32 34.1 30.2 36 27.9 36H12.1C9.8 36 8 34.1 8 31.8V22.1Z"
        fill="var(--marca-principal)"
      />
      <path
        d="M28.2 23.8C30.6 22.3 33.8 21.5 37.4 21.5C41.1 21.5 44.2 22.3 46.8 23.8V31.8C46.8 34.1 45 36 42.7 36H32.3C30 36 28.2 34.1 28.2 31.8V23.8Z"
        fill="var(--marca-acompanante)"
      />
    </svg>
  );
}
